<template>
  <div class="success-icon-wrapper">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"
        :fill="color"
      />
    </svg>
  </div>
</template>

<script>
export default {
  name: 'SuccessIcon',
  props: {
    color: {
      type: String,
      default: '#17a2b8'
    },
    size: {
      type: [String, Number],
      default: 120
    }
  }
}
</script>

<style scoped>
.success-icon-wrapper {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
</style>
